<template>
    <Paper :header="label">
        <LayoutToggles v-if="withLayoutToggle" slot="header" v-model="isList" />

        <div v-if="data.length > 0" :class="{ grid: !isList }">
            <div
                v-for="company in data"
                :key="company.id"
                style="background-color: white"
                @click="onClick(company.id)"
            >
                <div
                    class="h-100 clickable px-2 py-2"
                    :class="[
                        isList ? 'company-list-item' : 'company-grid-item',
                        isList && 'pr-4',
                    ]"
                >
                    <b-img
                        class="image-default"
                        :src="company.logo"
                        fluid
                        style="grid-row: span 2; align-self: center; justify-self: center;"
                    />
                    <div style="grid-row: span 2; align-self: center;">
                        <h5 class="title m-0" style="font-size: 18px;">
                            {{ company.name }}
                        </h5>
                        <h6 class="caption m-0 mute" style="font-size: 14px;">
                            {{ company.industries }}
                            <template
                                v-if="company.location || company.country"
                            >
                                {{ company.industries ? '|' : '' }}
                                {{ company.country }}
                                {{
                                    company.country && company.location
                                        ? ', '
                                        : ''
                                }}
                                {{ company.location }}
                            </template>
                        </h6>
                    </div>

                    <!--  <h5 class="secondary-color text-right m-0">
                        {{ company.jobCount }}
                    </h5>
                    <h6 class="caption text-right m-0">jobs</h6> -->
                    <!--  <h5 class="secondary-color text-right m-0">
                        {{ company.followerCount }}
                    </h5>
                    <h6 class="caption m-0">followers</h6> -->
                    <Divider v-if="isList" class="divider" />
                    <div
                        v-for="(item, index) in company.labels"
                        :key="index"
                        style="grid-row: span 2; align-self: center; justify-self: center;"
                    >
                        <b-img
                            v-if="item.type === 'img'"
                            rounded
                            :alt="item.text"
                            :src="item.img"
                            v-b-tooltip.hover
                            :title="item.tooltip"
                            width="60"
                        />
                        <b-badge
                            v-else
                            pill
                            class="subtitle px-3 m-1"
                            v-b-tooltip.hover
                            :title="item.tooltip"
                            style="color: var(--secondary); border: 1px solid var(--secondary); background-color: white; display: block; white-space: nowrap;"
                        >
                            {{ item.text }}
                        </b-badge>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="isLoading" class="py-2">
            <ListItemSkeleton v-for="i in 4" :key="i" :rows="3" small />
        </div>
        <div v-else-if="data.length === 0">
            <slot />
        </div>
    </Paper>
</template>

<script>
// Project components
import LayoutToggles from './LayoutToggles';
import ListItemSkeleton from '~/components/skeletons/ListItemSkeleton';

export default {
    name: 'CompanyList',
    components: {
        LayoutToggles,
        ListItemSkeleton,
    },
    props: {
        label: String,
        withLayoutToggle: Boolean,
        isLoading: Boolean,
        data: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        isList: false,
    }),
    methods: {
        onClick: function(id) {
            const url = this.$URLS.findcompanies.concat('/', id);
            this.$router.push(url);
        },
    },
};
</script>

<style scoped>
.grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    background-color: #f3f3f3;
    grid-gap: 1px;
}
.company-list-item {
    display: grid;
    grid-template-rows: 50px 50px;
    grid-template-columns: 100px 1fr auto auto;
    max-width: 100%;
    grid-column-gap: 1rem;
    grid-auto-flow: column;
    position: relative;
}

.company-grid-item {
    display: grid;
    grid-template-rows: repeat(6, auto);
    grid-template-columns: 1fr 1fr;
    grid-auto-flow: row;
    grid-column-gap: 1rem;
    grid-row-gap: 0.2rem;
    text-align: center;
    min-height: 160px;
}
.company-grid-item > *:nth-child(1) {
    padding-bottom: 20px;
    padding-top: 20px;
}
.company-grid-item > *:nth-child(-n + 3) {
    grid-column: span 2;
}
.company-grid-item > *:nth-child(2n + 5) {
    align-self: center;
    justify-self: start;
}

@media only screen and (max-width: 600px) {
    .grid {
        grid-template-columns: 1fr 1fr 1fr;
    }
    .company-list-item {
        grid-template-columns: 100px fit-content(100%) minmax(auto, 1fr) minmax(
                auto,
                1fr
            );
    }
    h5 {
        font-size: 14px;
    }
}

@media only screen and (max-width: 370px) {
    .grid {
        grid-template-columns: 1fr 1fr;
    }
}

.company h5 {
    align-self: end;
    margin-bottom: 0;
}
.company h6 {
    margin-bottom: 0;
}

.divider {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
}
</style>
